export default "__VITE_ASSET__DgboNTny__"